import React from 'react';
import styled from 'styled-components';
import Img_ from 'gatsby-image';
import { breakpoints } from '../constants';
import { FormattedMessage, injectIntl } from 'react-intl';

const NameCell = styled.td`
    vertical-align: middle !important;
`;

const StandCell = NameCell;

const LogoCell = styled.td`
    text-align: center;
    vertical-align: middle !important;
    // img {
    //     max-width: 200px;
    //     max-height: 100px;
    //     padding: 10px;
    // }
`;

const Img = styled(Img_)`
    width: 200px;
    max-height: 100px;
    margin: 5px;
    @media (max-width: ${breakpoints.mobile}) {
        width: 100px;
    }
`;

export default injectIntl(
    ({
        exhibitors,
        logos,
        intl,
        filter,
        filterOpened,
        toggleFilter,
        setExhibitorsFilter,
    }) => {
        const categories = [].concat(
            ...exhibitors.map(
                ({ node: { categories } }) =>
                    categories
                        ? categories.map(({ nameRu, nameEn, id }) => ({
                              id,
                              name: intl.locale === 'ru' ? nameRu : nameEn,
                          }))
                        : []
            )
        );

        let uniqCategoriesId = [];
        let uniqCategories = [];

        categories.forEach((value, index) => {
            if (!uniqCategoriesId.includes(value.id)) {
                uniqCategoriesId.push(value.id);
                uniqCategories.push(value);
            }
        });

        const defaultFilterLabel = intl.formatMessage({
            id: 'pages.exhibitors.filterDefault',
        });
        return (
            <div>
                <div
                    className={`dropdown ${filterOpened ? 'is-active' : ''}`}
                    onClick={toggleFilter}
                >
                    <div className="dropdown-trigger">
                        <button
                            className="button"
                            aria-haspopup="true"
                            aria-controls="dropdown-menu"
                        >
                            <span>
                                {filter ? filter.name : defaultFilterLabel}
                            </span>
                            <span className="icon is-small">
                                <i
                                    className="fas fa-angle-down"
                                    aria-hidden="true"
                                />
                            </span>
                        </button>
                    </div>
                    <div
                        className="dropdown-menu"
                        id="dropdown-menu"
                        role="menu"
                    >
                        <div className="dropdown-content">
                            <a
                                className={`dropdown-item ${
                                    !filter ? 'is-active' : ''
                                }`}
                                style={{ textDecoration: 'none' }}
                                onClick={() => setExhibitorsFilter(null)}
                            >
                                <FormattedMessage id="pages.exhibitors.filterAll" />
                            </a>
                            {uniqCategories.map(({ id, name }) => (
                                <a
                                    key={id}
                                    className={`dropdown-item ${
                                        filter && filter.name === name
                                            ? 'is-active'
                                            : ''
                                    }`}
                                    style={{ textDecoration: 'none' }}
                                    onClick={() =>
                                        setExhibitorsFilter({ id, name })
                                    }
                                >
                                    {name}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
                <table className="table">
                    <tbody>
                        {exhibitors
                            .filter(
                                ({ node: { categories } }) =>
                                    !filter ||
                                    categories.find(
                                        ({ id }) => id === filter.id
                                    )
                            )
                            .sort(
                                (a, b) => (a.node.name > b.node.name ? 1 : -1)
                            )
                            .map(({ node }) => {
                                const sizes = getLogoSizes(node.code, logos);
                                return (
                                    <tr key={node.id}>
                                        <NameCell>
                                            <a
                                                href={extractWebsite(
                                                    node.website
                                                )}
                                                target="__blank"
                                            >
                                                {node.name}
                                            </a>
                                        </NameCell>
                                        <NameCell>
                                            {node.categories &&
                                                node.categories.map((item) => (
                                                    <div key={item.id}>
                                                        {intl.locale === 'ru'
                                                            ? item.nameRu
                                                            : item.nameEn}
                                                    </div>
                                                ))}
                                        </NameCell>
                                        <LogoCell>
                                            {sizes && (
                                                <Img
                                                    sizes={sizes}
                                                    imgStyle={{
                                                        objectFit: 'contain',
                                                    }}
                                                />
                                            )}
                                        </LogoCell>
                                        <StandCell>{node.stand}</StandCell>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>
        );
    }
);

const getLogoSizes = (code, logos) => {
    const logo = logos.find(({ node }) => node.name === code);
    return logo && logo.node.childImageSharp.sizes;
};

const extractWebsite = (str) => {
    if (!str) {
        return 'javascript:;';
    }
    const url = (str && str.split(/[\s,;]/)[0]) || '';
    return url.substr(0, 4) === 'http' ? url : `http://${url}`;
};

export const query = graphql`
    fragment Exhibitors on RootQueryType {
        exhibitors: allExhibitor {
            edges {
                node {
                    id
                    code
                    name
                    website
                    stand
                    categories {
                        id
                        nameRu
                        nameEn
                    }
                }
            }
        }
        exhibitorsImages: allFile(
            filter: { sourceInstanceName: { eq: "exhibitors" } }
        ) {
            edges {
                node {
                    name
                    childImageSharp {
                        sizes(maxWidth: 200) {
                            ...GatsbyImageSharpSizes
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/ExhibitorsList.js